module.exports = __webpack_public_path__ + "static/5222-791b440f3e3fe73d47e04a8f30b09a2c.png";